import Alpine from "alpinejs"
import Cropper from "cropperjs"

Alpine.data("UploadCropDialog", () => ({
    imageUrl: "",
    fileName: "",
    cropper: null,
    crop: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    },

    init() {
        // Listen for dialog close event
        this.$root.addEventListener("dialog-closed", () => {
            this.cleanup()
        })
    },

    fileChosen(event) {
        if (this.cropper) {
            this.cropper.destroy()
            this.cropper = null
        }

        const file = event.target.files[0]
        if (file) {
            if (file.size > 3 * 1024 * 1024) {
                alert("File size must be less than 3MB")
                event.target.value = ""
                return
            }
            if (!["image/jpeg", "image/jpg"].includes(file.type)) {
                alert("Only JPG and JPEG files are allowed")
                event.target.value = ""
                return
            }

            this.fileName = file.name
            this.fileToDataUrl(event, (src) => {
                this.imageUrl = src
                this.$dispatch("image-selected", {
                    file: file,
                    dataUrl: src,
                    name: this.fileName,
                    fieldName: event.target.name,
                })

                // Only show dialog for the main image upload
                if (event.target.name !== "logo") {
                    const dialog = this.$root.querySelector("dialog")
                    if (dialog) {
                        dialog.showModal()
                        this.$nextTick(() => {
                            const image = dialog.querySelector("img")
                            this.initCropper(image)
                        })
                    }
                }
            })
        }
    },

    fileToDataUrl(event, callback) {
        if (!event.target.files.length) return

        let file = event.target.files[0],
            reader = new FileReader()

        reader.readAsDataURL(file)
        reader.onload = (e) => callback(e.target.result)
    },

    initCropper(image) {
        this.cropper = new Cropper(image, {
            viewMode: 1,
            dragMode: "move",
            aspectRatio: 552 / 334,
            autoCropArea: 0.8,
            restore: false,
            guides: false,
            center: false,
            highlight: true,
            cropBoxMovable: true,
            cropBoxResizable: true,
            toggleDragModeOnDblclick: false,
            ready: () => {
                const data = this.cropper.getData()
                this.updateCropData(data)
            },
            crop: (event) => {
                this.updateCropData(event.detail)
            },
        })
    },

    updateCropData(data) {
        this.crop = {
            x: Math.round(data.x),
            y: Math.round(data.y),
            width: Math.round(data.width),
            height: Math.round(data.height),
        }
        // Dispatch event when crop data changes
        this.$dispatch("crop-updated", {
            fieldName: this.$root.querySelector('input[type="file"]').name,
            cropData: this.crop,
        })
    },

    resetImage() {
        // Clean up cropper
        if (this.cropper) {
            this.cropper.destroy()
            this.cropper = null
        }

        // Reset state
        this.imageUrl = ""
        this.fileName = ""
        this.crop = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        }

        // Clear the file input
        const fileInput = this.$root.querySelector('input[type="file"]')
        if (fileInput) {
            fileInput.value = ""
        }

        // Dispatch reset event
        this.$dispatch("image-reset", {
            fieldName: fileInput ? fileInput.name : null,
        })
    },

    cleanup() {
        if (this.cropper) {
            this.cropper.destroy()
            this.cropper = null
        }
    },
}))

Alpine.data("cropDialog", () => ({
    init() {
        // Handle ESC key
        this.$root.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.$refs.dialog.open) {
                e.preventDefault()
                this.closeModal()
            }
        })
    },

    get open() {
        return this.$refs.dialog.open
    },

    showModal() {
        this.$refs.dialog.showModal()
    },

    closeModal() {
        // Dispatch event that dialog is being closed
        this.$root.dispatchEvent(new CustomEvent("dialog-closed"))
        // Close the dialog
        this.$refs.dialog.close()
    },
}))
